import { RETURN_METHOD_CATEGORY, RETURN_METHOD_TYPE, SHIPMENT_NOTIFICATION, CREATE_RETURN_IN_INTEGRATION_TYPE } from "./return-method-types";

/** values for custom Ioptions for addresses dropdowns */
export enum DROP_OFF_LOCATION {
    CUSTOM_ADRESS = 'CUSTOM_ADDRESS',
    FULFILLMENT_LOCATION = 'RESTOCK_TO_FULFILLMENT_LOCATION',
    DROPOFF_INTEGRATION = 'DROPOFF_INTEGRATION',
    DYNAMIC_ADDRESS = 'DYNAMIC_ADDRESS',
}

export const SHIPMENT_NOTIFICATIONS_MAP: IShipmentNotificationOption = {
    [SHIPMENT_NOTIFICATION.NONE_SHIPMENT_NOTIFICATION]:
    {
        value: SHIPMENT_NOTIFICATION.NONE_SHIPMENT_NOTIFICATION, label: 'NONE'
    },
    [SHIPMENT_NOTIFICATION.ONLY_ON_SHIPMENT_RECEIVED_NOTIFICATION]:
    {
        value: SHIPMENT_NOTIFICATION.ONLY_ON_SHIPMENT_RECEIVED_NOTIFICATION, label: 'ONLY_ON_SHIPMENT_RECEIVED_NOTIFICATION'
    },
    [SHIPMENT_NOTIFICATION.ONLY_ON_TRANSIT_SHIPMENT_NOTIFICATION]:
    {
        value: SHIPMENT_NOTIFICATION.ONLY_ON_TRANSIT_SHIPMENT_NOTIFICATION, label: 'ONLY_ON_TRANSIT_SHIPMENT_NOTIFICATION'
    },
    [SHIPMENT_NOTIFICATION.ON_ANY_UPDATE_SHIPMENT_NOTIFICATION]:
    {
        value: SHIPMENT_NOTIFICATION.ON_ANY_UPDATE_SHIPMENT_NOTIFICATION, label: 'ON_ANY_UPDATE_SHIPMENT_NOTIFICATION'
    },
}

export const RETURN_METHOD_TYPES_MAP: IReturnMethodTypeOption = {
    [RETURN_METHOD_TYPE.NO_SHIPMENT_REQUIRED]:
    {
        value: RETURN_METHOD_TYPE.NO_SHIPMENT_REQUIRED, label: 'NO_SHIPMENT_REQUIRED'
    },
    [RETURN_METHOD_TYPE.DROP_OFF_LOCATION]:
    {
        value: RETURN_METHOD_TYPE.DROP_OFF_LOCATION, label: 'RETURN_TO_DROP_OFF_LOCATION'
    },
    [RETURN_METHOD_TYPE.SHIP_WITH_ANY_CARRIER]:
    {
        value: RETURN_METHOD_TYPE.SHIP_WITH_ANY_CARRIER, label: 'SHIP_WITH_ANY_CARRIER'
    },
    [RETURN_METHOD_TYPE.SHIP_WITH_PRE_PAID_LABEL]:
    {
        value: RETURN_METHOD_TYPE.SHIP_WITH_PRE_PAID_LABEL, label: 'SHIP_WITH_PRE_PAID_LABEL'
    },
}

export const RETURN_METHOD_CATEGORY_TO_TYPE_MAP: IReturnMethodCategoryMap = {
    [RETURN_METHOD_CATEGORY.NO_SHIPMENT_REQUIRED]: RETURN_METHOD_TYPE.NO_SHIPMENT_REQUIRED,
    [RETURN_METHOD_CATEGORY.DROP_OFF_LOCATION]: RETURN_METHOD_TYPE.DROP_OFF_LOCATION,
    [RETURN_METHOD_CATEGORY.SHIP_WITH_ANY_CARRIER]: RETURN_METHOD_TYPE.SHIP_WITH_ANY_CARRIER,
    [RETURN_METHOD_CATEGORY.SHIP_WITH_PRE_PAID_LABEL]: RETURN_METHOD_TYPE.SHIP_WITH_PRE_PAID_LABEL,
}


type ICreateReturnInWmsTypeOption = {
    [key in CREATE_RETURN_IN_INTEGRATION_TYPE]: {value: CREATE_RETURN_IN_INTEGRATION_TYPE, label: string,}
}

export const CREATE_RETURN_IN_WMS_TYPES_MAP: ICreateReturnInWmsTypeOption = {
    [CREATE_RETURN_IN_INTEGRATION_TYPE.CREATE_RETURN_IN_INTEGRATION_ALL]:
    {
        value: CREATE_RETURN_IN_INTEGRATION_TYPE.CREATE_RETURN_IN_INTEGRATION_ALL, label: 'UPDATE_ALL'
    },
    [CREATE_RETURN_IN_INTEGRATION_TYPE.CREATE_RETURN_IN_INTEGRATION_NONE]:
    {
        value: CREATE_RETURN_IN_INTEGRATION_TYPE.CREATE_RETURN_IN_INTEGRATION_NONE, label: 'DO_NOT_UPDATE'
    },
    [CREATE_RETURN_IN_INTEGRATION_TYPE.CREATE_RETURN_IN_INTEGRATION_BY_LIST]:
    {
        value: CREATE_RETURN_IN_INTEGRATION_TYPE.CREATE_RETURN_IN_INTEGRATION_BY_LIST, label: 'BY_LIST'
    },
}

type IReturnMethodCategoryMap = {
    [key in RETURN_METHOD_CATEGORY]: RETURN_METHOD_TYPE
}

type IReturnMethodTypeOption = {
    [key in RETURN_METHOD_TYPE]: {value: RETURN_METHOD_TYPE, label: string,}
}

type IShipmentNotificationOption = {
    [key in SHIPMENT_NOTIFICATION]: {value: SHIPMENT_NOTIFICATION, label: string,}
}

export function populateShippingNotificationsList(getTranslation: (key: string, scope: string) => string) {
    const options = Object.keys(SHIPMENT_NOTIFICATIONS_MAP).map(k => {
        return SHIPMENT_NOTIFICATIONS_MAP[(k as unknown) as SHIPMENT_NOTIFICATION];
    });

    const translatedOptions = options.map(option => ({
        value: option.value,
        label: getTranslation(option.label, 'dashboard-return-method-editor')
    }));

    return translatedOptions;
}

export const AUTO_SELECT_OPTION = 'auto-select-cheapest';

export const OVERRIDDEN_BY_CONNECTION = '__OVERRIDDEN_BY_CONNECTION__';